import React, { useEffect, useState, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { LoadingScreen } from "../../../UiComponents/LoadingComponent";
import stared from "../../../asset/returnsandstatistics/images/stared.svg";
import { Link, useLocation } from "react-router-dom";
import { UrlPath } from "../../../../config/routeConfig";
import { getContactsInfoAction } from "../../../actions/contactsAction";
import { General } from "./General";
import { Addresses } from "./Addresses";
import { Others } from "./Others";
import "../../../investor/investor.css";

export const Contacts = (props) => {

  const locationData = useLocation();
  const dispatch = useDispatch();
  const params = useParams();
  const Gstate = useSelector((state) => state) || {};

  useEffect(() => {
    document.title = `Investor Details`;
    dispatch(getContactsInfoAction(params.ContactId));
  }, []);

  const selectedTypeValue=Gstate?.Contacts?.ContactInfo?.ContactInfo?.ContactTypeId || 1 ;
  const queryParams = new URLSearchParams(locationData.search);
  const paramValue = queryParams.get('ContactTypeId') || selectedTypeValue; 

  const [loading, setLoading] = useState(true);
  const [selectedContactInfoButton, setContactInfoButton] = useState(!locationData?.state?.ActiveContactInfoButton  ? 1 : locationData.state.ActiveContactInfoButton);


  const isEditable = Gstate.authorizationData.isEditable;

  const ContactInfo = Gstate?.Contacts.ContactInfo || [];

  useEffect(() => {
    ContactInfo && setLoading(false);
  }, [ ContactInfo]);

  const addressesData = ContactInfo?.ContactAddresses?.reduce((result, contact) => {
    const typeName = contact.ContactAddressTypeName;
    if (!result[typeName]) {
      result[typeName] = [];
    }
    result[typeName].push(contact);
    return result;
  }, {});

  const atributesData = ContactInfo?.ContactAttributes?.reduce((result, contact) => {
    const typeName = contact.ContactAttributeTypeName;
    if (!result[typeName]) {
      result[typeName] = [];
    }
    result[typeName].push(contact);
    return result;
  }, {});

  const home = addressesData?.Home[0];
  const business =  addressesData?.Business[0];
  const statement =  addressesData?.Statement[0];
  const other = addressesData?.Other[0];
  const anniversary = atributesData?.["Anniversary"]?.[0];
  const annualIncome = atributesData?.["Annual Income"]?.[0];
  const boardMember = atributesData?.["Board Member"]?.[0];
  const PersonalEmail1 = atributesData?.["Personal Email1"]?.[0];
  const PersonalEmail2 = atributesData?.["Personal Email2"]?.[0];
  const businessEmail1 = atributesData?.["Business Email1"]?.[0];
  const businessEmail2 = atributesData?.["Business Email2"]?.[0];
  const businessEmail3 = atributesData?.["Business Email3"]?.[0];
  const businessPhone1 = atributesData?.["Business Phone1"]?.[0];
  const businessPhone2 = atributesData?.["Business Phone2"]?.[0];
  const businessPhone1Extension = atributesData?.["BusinessPhone1Extension"]?.[0];
  const businessPhone2Extension = atributesData?.["BusinessPhone2Extension"]?.[0];
  const contactSource = atributesData?.["Contact Source"]?.[0];
  const department = atributesData?.["Department"]?.[0];
  const doNotEmail = atributesData?.["Do Not Email"]?.[0];
  const receivesEstimates = atributesData?.["Receives Estimates"]?.[0];
  const estimateAssest = atributesData?.["Estimate Assest"]?.[0];
  const faxNumber = atributesData?.["Fax Number"]?.[0];
  const introductionDate = atributesData?.["Introduction Date"]?.[0];
  const mobilePhone = atributesData?.["Mobile Phone"]?.[0];
  const externalRepID = atributesData?.["Rep ID"]?.[0];
  const repTypeID = atributesData?.["Rep Type ID"]?.[0];
  const leadId = atributesData?.["Lead ID"]?.[0];
  const socialSecurity = atributesData?.["Social Security"]?.[0];
  const spouseName = atributesData?.["Spouse Name"]?.[0];
  const taxIDNumber = atributesData?.["Tax ID Number"]?.[0];
  const primaryContact = atributesData?.["Primary Contact ID"]?.[0];

  const contactId = ContactInfo?.ContactInfo?.ContactId || ContactInfo?.ContactWebStatus?.ContactId;
  const contactTypeId = ContactInfo?.ContactInfo?.ContactTypeId;
  const contactSubTypeId = ContactInfo?.ContactInfo?.ContactSubTypeId;
  const companyName = ContactInfo?.ContactInfo?.CompanyName;
  const contactCategoryId = ContactInfo?.ContactInfo?.ContactCategoryId;
  const contactCategoryName = ContactInfo?.ContactInfo?.ContactCategoryName;
  const dateOfBirth = ContactInfo?.ContactInfo?.DateOfBirth;
  const firstName = ContactInfo?.ContactInfo?.FirstName;
  const lastName = ContactInfo?.ContactInfo?.LastName;
  const middleName = ContactInfo?.ContactInfo?.MiddleName;
  const motherMaidenName = ContactInfo?.ContactInfo?.MotherMaidenName;
  const preferredName = ContactInfo?.ContactInfo?.PreferredName;
  const salutation = ContactInfo?.ContactInfo?.Salutation;
  const title = ContactInfo?.ContactInfo?.Title;
  const jobTitle = ContactInfo?.ContactInfo?.JobTitle;
  const jobRole = ContactInfo?.ContactInfo?.JobRole;
  const isMaster = ContactInfo?.ContactInfo?.IsMaster;
  const isParentCompany = ContactInfo?.ContactInfo?.IsParentCompany;
  const isActive = ContactInfo?.ContactInfo?.IsActive;
  const contactNotes = ContactInfo?.ContactInfo?.ContactNotes;
  const biographicalInfo = ContactInfo?.ContactInfo?.BiographicalInfo;
  const createdByUserName = ContactInfo?.ContactInfo?.CreatedByUserName;
  const createdDate = ContactInfo?.ContactInfo?.CreatedDate;
  const modifiedDate = ContactInfo?.ContactInfo?.ModifiedDate;
  const CompanyTypeName=ContactInfo?.ContactInfo?.CompanyTypeName;
  const contactWebStatusId = ContactInfo?.ContactWebStatus?.ContactWebStatusId;
  const contactWebCategoryId = ContactInfo?.ContactWebStatus?.ContactWebCategoryId;
  const contactWebCategoryName = ContactInfo?.ContactWebStatus?.ContactWebCategoryName;
  const contactWebStatusTypeName = ContactInfo?.ContactWebStatus?.ContactWebStatusTypeName;
  const contactWebStatusTypeId = ContactInfo?.ContactWebStatus?.ContactWebStatusTypeId;
  const webUrl = ContactInfo?.ContactWebStatus?.WebUrl;
  const webUserId = ContactInfo?.ContactWebStatus?.WebUserId;
 
  const [generalData, setGeneralData] = useState({
    contactId: contactId,
    contactTypeId: contactTypeId,
    contactSubTypeId: contactSubTypeId,
    title: title,
    salutation: salutation,
    firstName: firstName,
    middleName: middleName,
    lastName: lastName,
    preferredName: preferredName,
    motherMaidenName: motherMaidenName,
    dateOfBirth: dateOfBirth,
    companyName: companyName,
    isParentCompany: isParentCompany,
    jobTitle: jobTitle,
    jobRole: jobRole,
    isMaster: isMaster,
    isActive: isActive,
    contactNotes: contactNotes,
    BiographicalInfo: biographicalInfo,
    contactCategoryId: contactCategoryId,
    contactCategoryName: contactCategoryName,
    createdByUserName: createdByUserName,
    createdDate: createdDate,
    CompanyTypeName:CompanyTypeName,
    socialSecurityAttributeId: socialSecurity?.ContactAttributeId,
    socialSecurityAttributeTypeId: socialSecurity?.ContactAttributeTypeId,
    socialSecurityValue: socialSecurity?.ContactAttributeTypeValue,
    socialSecurityIsEncrypted: socialSecurity?.IsEncrypted,

    taxIDAttributeId: taxIDNumber?.ContactAttributeId,
    taxIDAttributeTypeId: taxIDNumber?.ContactAttributeTypeId,
    taxIDValue: taxIDNumber?.ContactAttributeTypeValue,
    taxIDIsEncrypted: taxIDNumber?.IsEncrypted,

    departmentAttributeId: department?.ContactAttributeId,
    departmentAttributeTypeId: department?.ContactAttributeTypeId,
    departmentValue: department?.ContactAttributeTypeValue,
    departmentIsEncrypted: department?.IsEncrypted,

    businessPhone1AttributeId: businessPhone1?.ContactAttributeId,
    businessPhone1AttributeTypeId: businessPhone1?.ContactAttributeTypeId,
    businessPhone1Value: businessPhone1?.ContactAttributeTypeValue,
    businessPhone1IsEncrypted: businessPhone1?.IsEncrypted,

    businessPhone2AttributeId: businessPhone2?.ContactAttributeId,
    businessPhone2AttributeTypeId: businessPhone2?.ContactAttributeTypeId,
    businessPhone2Value: businessPhone2?.ContactAttributeTypeValue,
    businessPhone2IsEncrypted: businessPhone2?.IsEncrypted,

    businessPhone1ExtensionAttributeId: businessPhone1Extension?.ContactAttributeId,
    businessPhone1ExtensionAttributeTypeId: businessPhone1Extension?.ContactAttributeTypeId,
    businessPhone1ExtensionValue: businessPhone1Extension?.ContactAttributeTypeValue,
    businessPhone1ExtensionIsEncrypted: businessPhone1Extension?.IsEncrypted,

    businessPhone2ExtensionAttributeId: businessPhone2Extension?.ContactAttributeId,
    businessPhone2ExtensionAttributeTypeId: businessPhone2Extension?.ContactAttributeTypeId,
    businessPhone2ExtensionValue: businessPhone2Extension?.ContactAttributeTypeValue,
    businessPhone2ExtensionIsEncrypted: businessPhone2Extension?.IsEncrypted,

    PersonalEmail1AttributeId: PersonalEmail1?.ContactAttributeId,
    PersonalEmail1AttributeTypeId: PersonalEmail1?.ContactAttributeTypeId,
    PersonalEmail1Value: PersonalEmail1?.ContactAttributeTypeValue,
    PersonalEmail1IsEncrypted: PersonalEmail1?.IsEncrypted,

    PersonalEmail2AttributeId: PersonalEmail2?.ContactAttributeId,
    PersonalEmail2AttributeTypeId: PersonalEmail2?.ContactAttributeTypeId,
    PersonalEmail2Value: PersonalEmail2?.ContactAttributeTypeValue,
    PersonalEmail2IsEncrypted: PersonalEmail2?.IsEncrypted,

    mobileAttributeId: mobilePhone?.ContactAttributeId,
    mobileAttributeTypeId: mobilePhone?.ContactAttributeTypeId,
    mobileValue: mobilePhone?.ContactAttributeTypeValue,
    mobileIsEncrypted: mobilePhone?.IsEncrypted,

    faxAttributeId: faxNumber?.ContactAttributeId,
    faxAttributeTypeId: faxNumber?.ContactAttributeTypeId,
    faxValue: faxNumber?.ContactAttributeTypeValue,
    faxIsEncrypted: faxNumber?.IsEncrypted,

    businessEmail1AttributeId: businessEmail1?.ContactAttributeId,
    businessEmail1AttributeTypeId: businessEmail1?.ContactAttributeTypeId,
    businessEmail1Value: businessEmail1?.ContactAttributeTypeValue,
    businessEmail1IsEncrypted: businessEmail1?.IsEncrypted,

    businessEmail2AttributeId: businessEmail2?.ContactAttributeId,
    businessEmail2AttributeTypeId: businessEmail2?.ContactAttributeTypeId,
    businessEmail2Value: businessEmail2?.ContactAttributeTypeValue,
    businessEmail2IsEncrypted: businessEmail2?.IsEncrypted,

    businessEmail3AttributeId: businessEmail3?.ContactAttributeId,
    businessEmail3AttributeTypeId: businessEmail3?.ContactAttributeTypeId,
    businessEmail3Value: businessEmail3?.ContactAttributeTypeValue,
    businessEmail3IsEncrypted: businessEmail3?.IsEncrypted,

    externalRepAttributeId: externalRepID?.ContactAttributeId,
    externalRepAttributeTypeId: externalRepID?.ContactAttributeTypeId,
    externalRepValue: externalRepID?.ContactAttributeTypeValue,
    externalRepIsEncrypted: externalRepID?.IsEncrypted,

    repTypeAttributeId: repTypeID?.ContactAttributeId,
    repTypeAttributeTypeId: repTypeID?.ContactAttributeTypeId,
    repTypeValue: repTypeID?.ContactAttributeTypeValue,
    repTypeIsEncrypted: repTypeID?.IsEncrypted,

    leadAttributeId: leadId?.ContactAttributeId,
    leadAttributeTypeId: leadId?.ContactAttributeTypeId,
    leadValue: leadId?.ContactAttributeTypeValue,
    leadIsEncrypted: leadId?.IsEncrypted,

    introductionDateAttributeId: introductionDate?.ContactAttributeId,
    introductionDateAttributeTypeId: introductionDate?.ContactAttributeTypeId,
    introductionDateValue: introductionDate?.ContactAttributeTypeValue,
    introductionDateIsEncrypted: introductionDate?.IsEncrypted,   

    doNotEmailAttributeId: doNotEmail?.ContactAttributeId,
    doNotEmailAttributeTypeId: doNotEmail?.ContactAttributeTypeId,
    doNotEmailValue: doNotEmail?.ContactAttributeTypeValue,
    doNotEmailIsEncrypted: doNotEmail?.IsEncrypted,  
    
    primaryContactAttributeId: primaryContact?.ContactAttributeId,
    primaryContactAttributeTypeId: primaryContact?.ContactAttributeTypeId,
    primaryContactValue: primaryContact?.ContactAttributeTypeValue,
    primaryContactIsEncrypted: primaryContact?.IsEncrypted,  
  });

  useEffect(() => {
    setGeneralData({
      contactId: contactId,
      contactTypeId: contactTypeId,
      contactSubTypeId: contactSubTypeId,
      title: title,
      salutation: salutation,
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      preferredName: preferredName,
      motherMaidenName: motherMaidenName,
      dateOfBirth: dateOfBirth,
      companyName: companyName,
      CompanyTypeName:CompanyTypeName,
      isParentCompany: isParentCompany,
      jobTitle: jobTitle,
      jobRole: jobRole,
      isMaster: isMaster,
      isActive: isActive,
      contactNotes: contactNotes,
      BiographicalInfo: biographicalInfo,
      contactCategoryId: contactCategoryId,
      contactCategoryName: contactCategoryName,
      createdByUserName: createdByUserName,
      createdDate: createdDate,
  
      socialSecurityAttributeId: socialSecurity?.ContactAttributeId,
      socialSecurityAttributeTypeId: socialSecurity?.ContactAttributeTypeId,
      socialSecurityValue: socialSecurity?.ContactAttributeTypeValue,
      socialSecurityIsEncrypted: socialSecurity?.IsEncrypted,
  
      taxIDAttributeId: taxIDNumber?.ContactAttributeId,
      taxIDAttributeTypeId: taxIDNumber?.ContactAttributeTypeId,
      taxIDValue: taxIDNumber?.ContactAttributeTypeValue,
      taxIDIsEncrypted: taxIDNumber?.IsEncrypted,
  
      departmentAttributeId: department?.ContactAttributeId,
      departmentAttributeTypeId: department?.ContactAttributeTypeId,
      departmentValue: department?.ContactAttributeTypeValue,
      departmentIsEncrypted: department?.IsEncrypted,
  
      businessPhone1AttributeId: businessPhone1?.ContactAttributeId,
      businessPhone1AttributeTypeId: businessPhone1?.ContactAttributeTypeId,
      businessPhone1Value: businessPhone1?.ContactAttributeTypeValue,
      businessPhone1IsEncrypted: businessPhone1?.IsEncrypted,
  
      businessPhone2AttributeId: businessPhone2?.ContactAttributeId,
      businessPhone2AttributeTypeId: businessPhone2?.ContactAttributeTypeId,
      businessPhone2Value: businessPhone2?.ContactAttributeTypeValue,
      businessPhone2IsEncrypted: businessPhone2?.IsEncrypted,
  
      businessPhone1ExtensionAttributeId: businessPhone1Extension?.ContactAttributeId,
      businessPhone1ExtensionAttributeTypeId: businessPhone1Extension?.ContactAttributeTypeId,
      businessPhone1ExtensionValue: businessPhone1Extension?.ContactAttributeTypeValue,
      businessPhone1ExtensionIsEncrypted: businessPhone1Extension?.IsEncrypted,
  
      businessPhone2ExtensionAttributeId: businessPhone2Extension?.ContactAttributeId,
      businessPhone2ExtensionAttributeTypeId: businessPhone2Extension?.ContactAttributeTypeId,
      businessPhone2ExtensionValue: businessPhone2Extension?.ContactAttributeTypeValue,
      businessPhone2ExtensionIsEncrypted: businessPhone2Extension?.IsEncrypted,
  
      mobileAttributeId: mobilePhone?.ContactAttributeId,
      mobileAttributeTypeId: mobilePhone?.ContactAttributeTypeId,
      mobileValue: mobilePhone?.ContactAttributeTypeValue,
      mobileIsEncrypted: mobilePhone?.IsEncrypted,
  
      faxAttributeId: faxNumber?.ContactAttributeId,
      faxAttributeTypeId: faxNumber?.ContactAttributeTypeId,
      faxValue: faxNumber?.ContactAttributeTypeValue,
      faxIsEncrypted: faxNumber?.IsEncrypted,

      PersonalEmail1AttributeId: PersonalEmail1?.ContactAttributeId,
      PersonalEmail1AttributeTypeId: PersonalEmail1?.ContactAttributeTypeId,
      PersonalEmail1Value: PersonalEmail1?.ContactAttributeTypeValue,
      PersonalEmail1IsEncrypted: PersonalEmail1?.IsEncrypted,

      PersonalEmail2AttributeId: PersonalEmail2?.ContactAttributeId,
      PersonalEmail2AttributeTypeId: PersonalEmail2?.ContactAttributeTypeId,
      PersonalEmail2Value: PersonalEmail2?.ContactAttributeTypeValue,
      PersonalEmail2IsEncrypted: PersonalEmail2?.IsEncrypted,
  
      businessEmail1AttributeId: businessEmail1?.ContactAttributeId,
      businessEmail1AttributeTypeId: businessEmail1?.ContactAttributeTypeId,
      businessEmail1Value: businessEmail1?.ContactAttributeTypeValue,
      businessEmail1IsEncrypted: businessEmail1?.IsEncrypted,
  
      businessEmail2AttributeId: businessEmail2?.ContactAttributeId,
      businessEmail2AttributeTypeId: businessEmail2?.ContactAttributeTypeId,
      businessEmail2Value: businessEmail2?.ContactAttributeTypeValue,
      businessEmail2IsEncrypted: businessEmail2?.IsEncrypted,
  
      businessEmail3AttributeId: businessEmail3?.ContactAttributeId,
      businessEmail3AttributeTypeId: businessEmail3?.ContactAttributeTypeId,
      businessEmail3Value: businessEmail3?.ContactAttributeTypeValue,
      businessEmail3IsEncrypted: businessEmail3?.IsEncrypted,
  
      externalRepAttributeId: externalRepID?.ContactAttributeId,
      externalRepAttributeTypeId: externalRepID?.ContactAttributeTypeId,
      externalRepValue: externalRepID?.ContactAttributeTypeValue,
      externalRepIsEncrypted: externalRepID?.IsEncrypted,
  
      repTypeAttributeId: repTypeID?.ContactAttributeId,
      repTypeAttributeTypeId: repTypeID?.ContactAttributeTypeId,
      repTypeValue: repTypeID?.ContactAttributeTypeValue,
      repTypeIsEncrypted: repTypeID?.IsEncrypted,
  
      leadAttributeId: leadId?.ContactAttributeId,
      leadAttributeTypeId: leadId?.ContactAttributeTypeId,
      leadValue: leadId?.ContactAttributeTypeValue,
      leadIsEncrypted: leadId?.IsEncrypted,
  
      introductionDateAttributeId: introductionDate?.ContactAttributeId,
      introductionDateAttributeTypeId: introductionDate?.ContactAttributeTypeId,
      introductionDateValue: introductionDate?.ContactAttributeTypeValue,
      introductionDateIsEncrypted: introductionDate?.IsEncrypted,   
  
      doNotEmailAttributeId: doNotEmail?.ContactAttributeId,
      doNotEmailAttributeTypeId: doNotEmail?.ContactAttributeTypeId,
      doNotEmailValue: doNotEmail?.ContactAttributeTypeValue,
      doNotEmailIsEncrypted: doNotEmail?.IsEncrypted, 

      primaryContactAttributeId: primaryContact?.ContactAttributeId,
      primaryContactAttributeTypeId: primaryContact?.ContactAttributeTypeId,
      primaryContactValue: primaryContact?.ContactAttributeTypeValue,
      primaryContactIsEncrypted: primaryContact?.IsEncrypted,  
    });    
  }, [
    contactId,
    contactTypeId,
    contactSubTypeId,
    title,
    salutation,
    firstName,
    middleName,
    lastName,
    preferredName,
    motherMaidenName,
    dateOfBirth,
    companyName,
    CompanyTypeName,
    isParentCompany,
    jobTitle,
    jobRole,
    isMaster,
    isActive,
    contactCategoryId,
    contactCategoryName,
    contactNotes,
    createdByUserName,
    createdDate,
    socialSecurity,
    taxIDNumber,
    department,
    businessPhone1,
    businessPhone2,
    businessPhone1Extension,
    businessPhone2Extension,
    mobilePhone,
    faxNumber,
    PersonalEmail1,
    PersonalEmail2,
    businessEmail1,
    businessEmail2,
    businessEmail3,
    externalRepID,
    repTypeID,
    leadId,
    introductionDate,
    doNotEmail,
    primaryContact,
  ]);

  const [addressData, setAddressData] = useState({
    contactId: contactId,
    homeAddressId: home?.ContactAddressId,
    homeAddressTypeId: home?.ContactAddressTypeId,
    home: home?.ContactAddressTypeName,
    homeNote: home?.Note,
    homeProvince: home?.AddressProvince,
    homeCity: home?.AddressCity,
    homeCountry: home?.AddressCountry,
    homeCountryId: home?.AddressCountryId,
    homeState: home?.AddressState,
    homePhone: home?.AddressZip,
    homeAddressStreet1: home?.AddressStreet,
    homeAddressStreet2: home?.AddressStreet2,
    homeZip: home?.AddressZip,
    homeUseforInvoicing: home?.IsInvoicingAddress,
    businessAddressId: business?.ContactAddressId,
    businessAddressTypeId: business?.ContactAddressTypeId,
    business: business?.ContactAddressTypeName,
    businessNote: business?.Note,
    businessProvince: business?.AddressProvince,
    businessCity: business?.AddressCity,
    businessCountry: business?.AddressCountry,
    businessCountryId: business?.AddressCountryId,
    businessState: business?.AddressState,
    businessAddressStreet1: business?.AddressStreet,
    businessAddressStreet2: business?.AddressStreet2,
    businessZip: business?.AddressZip,
    businessUseforInvoicing: business?.IsInvoicingAddress,
    statementAddressId: statement?.ContactAddressId,
    statementAddressTypeId: statement?.ContactAddressTypeId,
    statement: statement?.ContactAddressTypeName,
    statementNote: statement?.Note,
    statementAddressProvince: statement?.AddressProvince,
    statementAddressCity: statement?.AddressCity,
    statementAddressCountry: statement?.AddressCountry,
    statementAddressCountryId: statement?.AddressCountryId,
    statementAddressState: statement?.AddressState,
    statementAddressStreet1: statement?.AddressStreet,
    statementAddressStreet2: statement?.AddressStreet2,
    statementAddressZip: statement?.AddressZip,
    statementUseforInvoicing: statement?.IsInvoicingAddress,
  });

  useEffect(() => {
    setAddressData({
      contactId: contactId,
      homeAddressId: home?.ContactAddressId,
      homeAddressTypeId: home?.ContactAddressTypeId,
      home: home?.ContactAddressTypeName,
      homeNote: home?.Note,
      homeProvince: home?.AddressProvince,
      homeCity: home?.AddressCity,
      homeCountry: home?.AddressCountry,
      homeCountryId: home?.AddressCountryId,
      homeState: home?.AddressState,
      homePhone: home?.AddressZip,
      homeAddressStreet1: home?.AddressStreet,
      homeAddressStreet2: home?.AddressStreet2,
      homeZip: home?.AddressZip,
      homeUseforInvoicing: home?.IsInvoicingAddress,
      businessAddressId: business?.ContactAddressId,
      businessAddressTypeId: business?.ContactAddressTypeId,
      business: business?.ContactAddressTypeName,
      businessNote: business?.Note,
      businessProvince: business?.AddressProvince,
      businessCity: business?.AddressCity,
      businessCountry: business?.AddressCountry,
      businessCountryId: business?.AddressCountryId,
      businessState: business?.AddressState,
      businessAddressStreet1: business?.AddressStreet,
      businessAddressStreet2: business?.AddressStreet2,
      businessZip: business?.AddressZip,
      businessUseforInvoicing: business?.IsInvoicingAddress,
      statementAddressId: statement?.ContactAddressId,
      statementAddressTypeId: statement?.ContactAddressTypeId,
      statement: statement?.ContactAddressTypeName,
      statementNote: statement?.Note,
      statementAddressProvince: statement?.AddressProvince,
      statementAddressCity: statement?.AddressCity,
      statementAddressCountry: statement?.AddressCountry,
      statementAddressCountryId: statement?.AddressCountryId,
      statementAddressState: statement?.AddressState,
      statementAddressStreet1: statement?.AddressStreet,
      statementAddressStreet2: statement?.AddressStreet2,
      statementAddressZip: statement?.AddressZip,
      statementUseforInvoicing: statement?.IsInvoicingAddress,
    });
  }, [
    contactId,
    home,
    business,
    statement,  
  ]);

  const [othersData, setOthersData] = useState({
    contactId: contactId,
    webUserId: webUserId,
    contactWebStatusId: contactWebStatusId,
    contactWebStatusTypeId: contactWebStatusTypeId,
    contactWebStatusTypeName: contactWebStatusTypeName,
    contactWebCategoryId: contactWebCategoryId,
    contactWebCategoryName: contactWebCategoryName,
    webUrl: webUrl,
    modifiedDate: modifiedDate,

    anniversaryAttributeId: anniversary?.ContactAttributeId,
    anniversaryAttributeTypeId: anniversary?.ContactAttributeTypeId,
    anniversary: anniversary?.ContactAttributeTypeValue,
    anniversaryIsEncrypted: anniversary?.IsEncrypted,

    spouseAttributeId: spouseName?.ContactAttributeId,
    spouseAttributeTypeId: spouseName?.ContactAttributeTypeId,
    spouseName: spouseName?.ContactAttributeTypeValue,
    spouseIsEncrypted: spouseName?.IsEncrypted,

    contactSourceAttributeId: contactSource?.ContactAttributeId,
    contactSourceAttributeTypeId: contactSource?.ContactAttributeTypeId,
    contactSource: contactSource?.ContactAttributeTypeValue,
    contactSourceIsEncrypted: contactSource?.IsEncrypted,

    annualIncomeAttributeId: annualIncome?.ContactAttributeId,
    annualIncomeAttributeTypeId: annualIncome?.ContactAttributeTypeId,
    annualIncome: annualIncome?.ContactAttributeTypeValue,
    annualIncomeIsEncrypted: annualIncome?.IsEncrypted,

    receivesEstimatesAttributeId: receivesEstimates?.ContactAttributeId,
    receivesEstimatesAttributeTypeId: receivesEstimates?.ContactAttributeTypeId,
    receivesEstimates: receivesEstimates?.ContactAttributeTypeValue !== 0 ?  "Yes" : "No",
    receivesEstimatesIsEncrypted: receivesEstimates?.IsEncrypted,

    estimateAssestAttributeId: estimateAssest?.ContactAttributeId,
    estimateAssestAttributeTypeId: estimateAssest?.ContactAttributeTypeId,
    estimateAssest: estimateAssest?.ContactAttributeTypeValue,    
    estimateAssestIsEncrypted: estimateAssest?.IsEncrypted,

    boardMemberAttributeId: boardMember?.ContactAttributeId,
    boardMemberAttributeTypeId: boardMember?.ContactAttributeTypeId,
    boardMember: boardMember?.ContactAttributeTypeValue,    
    boardMemberIsEncrypted: boardMember?.IsEncrypted, 
  });

  useEffect(() => {
    setOthersData({
      contactId: contactId,
      contactNotes: contactNotes,
      webUserId: webUserId,
      contactWebStatusId: contactWebStatusId,
      contactWebStatusTypeId: contactWebStatusTypeId,
      contactWebStatusTypeName: contactWebStatusTypeName,
      contactWebCategoryId: contactWebCategoryId,
      contactWebCategoryName: contactWebCategoryName,
      webUrl: webUrl,
      modifiedDate: modifiedDate,

      anniversaryAttributeId: anniversary?.ContactAttributeId,
      anniversaryAttributeTypeId: anniversary?.ContactAttributeTypeId,
      anniversary: anniversary?.ContactAttributeTypeValue,
      anniversaryIsEncrypted: anniversary?.IsEncrypted,

      spouseAttributeId: spouseName?.ContactAttributeId,
      spouseAttributeTypeId: spouseName?.ContactAttributeTypeId,
      spouseName: spouseName?.ContactAttributeTypeValue,
      spouseIsEncrypted: spouseName?.IsEncrypted,

      contactSourceAttributeId: contactSource?.ContactAttributeId,
      contactSourceAttributeTypeId: contactSource?.ContactAttributeTypeId,
      contactSource: contactSource?.ContactAttributeTypeValue,
      contactSourceIsEncrypted: contactSource?.IsEncrypted,

      annualIncomeAttributeId: annualIncome?.ContactAttributeId,
      annualIncomeAttributeTypeId: annualIncome?.ContactAttributeTypeId,
      annualIncome: annualIncome?.ContactAttributeTypeValue,
      annualIncomeIsEncrypted: annualIncome?.IsEncrypted,

      receivesEstimatesAttributeId: receivesEstimates?.ContactAttributeId,
      receivesEstimatesAttributeTypeId: receivesEstimates?.ContactAttributeTypeId,
      receivesEstimates: receivesEstimates ?.ContactAttributeTypeValue !== null ? receivesEstimates ?.ContactAttributeTypeValue ? "Yes" : "No" : "",
      receivesEstimatesIsEncrypted: receivesEstimates?.IsEncrypted,

      estimateAssestAttributeId: estimateAssest?.ContactAttributeId,
      estimateAssestAttributeTypeId: estimateAssest?.ContactAttributeTypeId,
      estimateAssest: estimateAssest?.ContactAttributeTypeValue,    
      estimateAssestIsEncrypted: estimateAssest?.IsEncrypted, 

      boardMemberAttributeId: boardMember?.ContactAttributeId,
      boardMemberAttributeTypeId: boardMember?.ContactAttributeTypeId,
      boardMember: boardMember?.ContactAttributeTypeValue,    
      boardMemberIsEncrypted: boardMember?.IsEncrypted, 
    });
  }, [
    contactId,
    anniversary,
    spouseName,
    contactNotes,
    contactSource,
    annualIncome,
    receivesEstimates,
    webUserId,
    contactWebStatusTypeName,
    contactWebCategoryName,
    webUrl,
    boardMember,
    estimateAssest,  
    modifiedDate,  
  ]);

  const buttonNames = contactTypeId==1? [
    { buttonIds: 1, name: "General" },
    { buttonIds: 2, name: "Addresses" },
    { buttonIds: 3, name: "Others" },
  ]:[{ buttonIds: 1, name: "General" },
  { buttonIds: 2, name: "Addresses" }];

  const ContactInfoButtons = buttonNames.map((button, index) => (
    <button
      key={index}
      id={`button-${button.buttonIds}`}
      className={`non-gappable-button ${selectedContactInfoButton === button.buttonIds
        ? "selected-non-gappable-button"
        : ""
        }`}
      onClick={() => contactInfoButtonClick(button.buttonIds)}
    >
      {button.name}
    </button>
  ));

  const contactInfoButtonClick = (buttonId) => {
    setContactInfoButton(buttonId);
  };

  let componentToRender;

  switch (selectedContactInfoButton) {
    case 1:
      componentToRender = <General contactData={generalData}/>;
      break;
    case 2:
      componentToRender = <Addresses contactData={addressData}/>;
      break;
    case 3:
      componentToRender = <Others contactData={othersData}/>;
      break;
    default:
      componentToRender = null;
  }

  return (
    <>
      {loading ? (
        <>
          <LoadingScreen />
        </>
      ) : (
        <>
          <div id="contacts" className="mainContentData">
            <div className="container-fluid">
              <div className="d-flex justify-content-between align-items-center">
                <div className="button-container">{ContactInfoButtons}</div>
                <div className="d-flex justify-content-end align-items-center gap-4">
                  <Link
                    title="Click to edit Details"
                    to={
                      isEditable &&
                      `${UrlPath.InvestorDetailsEdit}${contactId}?ContactTypeId=${paramValue}`
                    }
                    state={{
                      SelectedContactInfoButton: selectedContactInfoButton, ContactDetails: generalData, AddressData: addressData, OthersData: othersData
                    }}
                    className={isEditable ? "" : "disabledControl"}
                  >
                    <i className="fa-solid fa-pencil edit_icon"></i>
                  </Link>
                  {/* <a href="#">
                    <img src={stared} alt="" />
                  </a> */}
                </div>
              </div>
              <div className="content-container">{componentToRender}</div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
